import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import { repoFileUpload, listTableColumnFetch, createRepo, get3dRepo} from '../../services/apiService';
import Form from "../../components/form/Form";
import { AxiosError } from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons';


interface RepoProps {
    setError: Dispatch<SetStateAction<string | null>>;
    setIsError: Dispatch<SetStateAction<boolean>>;
}

const Repo: React.FC<RepoProps> = ({ setError, setIsError }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingMes,setLoadingMes]= useState('')
    const [repoData,setRepoData] = useState<any[]>([{name:'',label:'',model_type:'',model_url:'',image_url:'',android_app_url:'',ios_app_url:'',webgl_app_url:'',spatial_app_url:'',edit:false}]);
    const [modelTypes,setModelTypes] = useState([])
    const [editOrNotPopup,setEditOrNotPopup] = useState(true)
    const [repoListShow,setRepoListShow] = useState(false)
    const [repoList,setRepoList] = useState([])
    const [alreadyModelUploaded,setAlreadyModelUploaded] = useState(false);
    const [alreadyImageUploaded,setAlreadyImageUploaded] = useState(false);
    const [alreadyAndroidAssestUploaded,setAlreadyAndroidAssestUploaded] = useState(false);
    const [alreadyIosAssestUploaded,setAlreadyIosAssestUploaded] = useState(false);
    const [alreadyWebglAssestUploaded,setAlreadyWebglAssestUploaded] = useState(false);
    const [alreadySpatialAssestUploaded,setAlreadySpatialAssestUploaded] = useState(false);
    const [edit,setEdit] = useState(false)
    useEffect(()=>{
        if(repoData[0]['model_url']){
            setAlreadyModelUploaded(true)
        }
        if(repoData[0]['image_url']){
            setAlreadyImageUploaded(true)
        }
        if(repoData[0]['android_app_url']){
            setAlreadyAndroidAssestUploaded(true)
        }
        if(repoData[0]['ios_app_url']){
            setAlreadyIosAssestUploaded(true)
        }
        if(repoData[0]['webgl_app_url']){
            setAlreadyWebglAssestUploaded(true)
        }
        if(repoData[0]['spatial_app_url']){
            setAlreadySpatialAssestUploaded(true)
        }
    },[repoData])

    const breadcrumbs = [
        { label: '3D Repository', href: '' },
    ];

    const fields = [
        { name:'column_title', label: 'Basic Details', placeholder: 'column_title',type:'column_title'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},
        { name: 'name', label: 'Model Name', placeholder: 'Enter the name of your 3D model', must:true},
        { name: 'label', label: 'Model Lable', placeholder: 'Enter the lable of your 3D model',required:true, must:true},
        { name: 'model_type', label: 'Choose a Type', placeholder: 'Type',type:'select', must:true},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},

        { name:'column_title', label: 'Model Upload', placeholder: 'column_title',type:'column_title'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},
        { name: 'select_repo_model', label: 'Upload your 3D Model (.fbx within 50 mb)', placeholder: 'select model' , type:'file'},
        { name: 'repo_model_button', label: 'Upload Repo Model', placeholder: 'Upload Repo Model',type:'button'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},

        { name:'column_title', label: 'Image Upload', placeholder: 'column_title',type:'column_title'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},
        { name: 'select_model_image', label: 'Upload Your Thumbnail image', placeholder: 'select image' , type:'file', must:true},
        { name: 'model_img_button', label: 'Upload Thumbnail Image', placeholder: 'Upload Thumbnail Image',type:'button'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},
        
        { name:'column_title', label: 'Assets Upload', placeholder: 'column_title',type:'column_title'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},
        { name: 'repo_android_app_asset', label: 'Repo Android Assests', placeholder: 'Android App Assests' , type:'file', must:true},
        { name: 'repo_android_button', label: 'Repo Upload Android Assest', placeholder: 'Upload Android',type:'button'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},

        { name: 'repo_ios_app_asset', label: 'Repo IOS Assest', placeholder: 'IOS App Assest' , type:'file', must:true},
        { name: 'repo_ios_button', label: 'Repo Upload IOS Assest', placeholder: 'Upload IOS',type:'button'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},

        { name: 'repo_webgl_app_asset', label: 'Repo Webgl Assest', placeholder: 'Webgl App Assest' , type:'file', must:true},
        { name: 'repo_webgl_button', label: 'Repo Upload Webgl Assest', placeholder: 'Upload Webgl',type:'button'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},

        { name: 'repo_spatial_app_asset', label: 'Repo Spatial Assest', placeholder: 'Repo Spatial App Assest' , type:'file'},
        { name: 'repo_spatial_button', label: 'Repo Upload Spatial Assest', placeholder: 'Repo Upload Spatial',type:'button'},
    ]

    const [repoFields, setRepoFields] = useState<{ [key: string]: typeof fields }[]>([]);

    useEffect(()=>{
        setRepoFields([{ project: [...fields] }]);

        async function colFetchFun1(){
            const res = await listTableColumnFetch('threeDModelTypes')
            const values = res.data.column_data.filter((val:string)=> (val !== null && val !== ''))
            setModelTypes(values)

            const list = await get3dRepo()
            setRepoList(list)

            setLoading(false)
        }
        colFetchFun1()
    },[])

    const model_upload = async (formData:any) => {
        if(!edit && repoList.some((list:any)=> list.name.toLowerCase() === repoData[0].name.toLowerCase())){
            alert('Model Name Already Exist')
        }
        else{
            setLoading(true)
            setLoadingMes('uploading')
            const file = formData.get('file');  
            const fileName = file && file.name; 
            const fileExtension = fileName.split('.').pop(); 
            if(fileExtension === 'fbx'){
                formData.append('type', 'model');
                const result = await repoFileUpload(formData)
                setRepoData((prevData) => {
                    const updatedProjectData = [...prevData];
                    if (updatedProjectData.length > 0) {
                        updatedProjectData[0].model_url = result.data.s3_key;
                    } else {
                        updatedProjectData.push({ model_url: result.data.s3_key });
                    }
                    return updatedProjectData;
                });
                setLoading(false);
                return result
            }
            else{
                alert('only ".fbx" files accepted')
                const result = {status : 4000}
                setLoading(false);
                return result
            }
        }
    }

    const image_upload = (formData:any) => {
        if(!edit && repoList.some((list:any)=> list.name.toLowerCase() === repoData[0].name.toLowerCase())){
            alert('Model Name Already Exist')
        }
        else{
            setLoading(true);
            setLoadingMes('uploading');
            return new Promise((resolve, reject) => {
                const file = formData.get('file');
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                if(fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg') {
                    const img = new Image();
                    img.onload = async () => {
                        formData.append('type', 'image');
                        const result = await repoFileUpload(formData);
                        setRepoData((prevData) => {
                            const updatedProjectData = [...prevData];
                            if (updatedProjectData.length > 0) {
                                updatedProjectData[0].image_url = result.data.file_url;
                            } else {
                                updatedProjectData.push({ image_url: result.data.file_url });
                            }
                            return updatedProjectData;
                        });
                        setLoading(false);
                        resolve(result);
                    };
                    img.onerror = () => {
                        alert('Error loading image');
                        setLoading(false);
                        reject(new Error('Error loading image'));
                    };
                    img.src = URL.createObjectURL(file);
                } else {
                    alert('Only ".png" and ".jpeg" are allowed for branding image');
                    setLoading(false);
                    resolve({ status: 2000 });
                }
            });
        }
    };

    async function assetUpload(formData:any){
        if(!edit && repoList.some((list:any)=> list.name.toLowerCase() === repoData[0].name.toLowerCase())){
            alert('Model Name Already Exist')
        }
        else{
            setLoading(true)
            setLoadingMes('uploading')
            const type = formData.get('type'); 
            if(repoData[0].hasOwnProperty('name') && repoData[0]['name']){
                formData.append('name', repoData[0]['name']);
                try{
                    const result = await repoFileUpload(formData)
                    setRepoData((prevData) => {
                        const updatedProjectData = [...prevData];
                        if (updatedProjectData.length > 0) {
                            if(type == 'android'){
                                updatedProjectData[0].android_app_url = result.data.s3_key;
                            }
                            else if(type == 'ios'){
                                updatedProjectData[0].ios_app_url = result.data.s3_key;
                            }
                            else if(type == 'webgl'){
                                updatedProjectData[0].webgl_app_url = result.data.s3_key;
                            }
                            else if(type == 'spatial'){
                                updatedProjectData[0].spatial_app_url = result.data.s3_key;
                            }
                        } else {
                            if(type == 'android'){
                                updatedProjectData.push({ android_app_url: result.data.s3_key });
                            }
                            else if(type == 'ios'){
                                updatedProjectData.push({ ios_app_url: result.data.s3_key });
                            }
                            else if(type == 'webgl'){
                                updatedProjectData.push({ webgl_app_url: result.data.s3_key });
                            }
                            else if(type == 'spatial'){
                                updatedProjectData.push({ spatial_app_url: result.data.s3_key });
                            }
                        }
                        return updatedProjectData;
                    });
                    setLoading(false);
                    return result
                }
                catch(err){
                    alert('upload failed')
                    const result = {status : 4000}
                    setLoading(false);
                    return result
                }
            }
            else{
                alert('Enter name of the model to upload asset')
                const result = {status : 4000}
                setLoading(false);
                return result
            }
        }
    }

    const handleRepoChange = (
        e: (React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>),
            index: number,
            field: boolean
        ) => {
            const name = e.target.name 
            const value = e.target.value

            setRepoData((prev: any[]) => {
                const updatedProject = [...prev];
                const project = updatedProject[index] || {};
                project[name] = value;
                updatedProject[index] = project;
                return updatedProject;
            });
            
    };

    useEffect(()=>{
        if(!edit && repoList.some((list:any)=> list.name.toLowerCase() === repoData[0].name.toLowerCase())){
            alert('This model name already exist')
        }
    },[repoData])

    async function submit(e:any){
        e.preventDefault();
        if(!edit && repoList.some((list:any)=> list.name.toLowerCase() === repoData[0].name.toLowerCase())){
            alert('Model Name Already Exist')
        }
        else{
            setLoading(true);
            setLoadingMes('saving');
            try {
                const result = await createRepo(repoData);
                if (result.status == 200) {
                    if(result.data.message == 'failed'){
                        setIsError(true);
                        setError(result.data.message);
                    }
                    else{
                        if(edit){
                            alert('Model updated to repository')
                        }
                        else{
                            alert('New model added to repository')
                        }
                        window.location.reload()
                    }
                } else {
                    console.log(result);
                }
            
            } catch (error) {
                setIsError(true);
                if (error instanceof AxiosError && error.response) {
                    if(error.response.data.error?.includes('Name has already been taken')){
                        setError('Story name has already been taken');
                    }
                    if(error?.response?.data?.error?.includes("Account must exist, Account can't be blank, Code can't be blank, Name can't be blank")){
                        setError('code has already been taken');
                    }
                } else {
                    setError("An unexpected error occurred");
                }
            } finally {
                setLoading(false);
            }
        }
    }

    return  <>
                <Breadcrumb breadcrumbs={breadcrumbs} />
                <form onSubmit={submit}>
                    <div className="px-10 flex justify-between items-center mb-5">
                            <div className="px-10 py-5 ps-0 text-lg flex">
                                    <p className='mr-4' style={{fontSize:'30px',color:'#0050C8',fontWeight:'bold'}}>3D Repository Upload</p>
                                            {/* {index !== 0 &&  */}
                                                {/* <button type="button" className="flex items-center"><FontAwesomeIcon icon={faTrash} className='text-sm' /></button>} */}
                            </div>
                            <button
                                disabled={repoData.length != 0 && ((!repoData[0].hasOwnProperty('android_app_url') || repoData[0]['android_app_url'] === '' || repoData[0]['android_app_url'] === null) || (!repoData[0].hasOwnProperty('ios_app_url') || repoData[0]['ios_app_url'] === '' || repoData[0]['ios_app_url'] === null) || (!repoData[0].hasOwnProperty('webgl_app_url') || repoData[0]['webgl_app_url'] === '' || repoData[0]['webgl_app_url'] === null) || (!repoData[0].hasOwnProperty('image_url') || repoData[0]['image_url'] === '' || repoData[0]['image_url'] === null))}
                                type="submit"
                                style={{backgroundColor:`${(repoData.length != 0 && ((!repoData[0].hasOwnProperty('android_app_url') || repoData[0]['android_app_url'] === '' || repoData[0]['android_app_url'] === null) || (!repoData[0].hasOwnProperty('ios_app_url') || repoData[0]['ios_app_url'] === '' || repoData[0]['ios_app_url'] === null) || (!repoData[0].hasOwnProperty('webgl_app_url') || repoData[0]['webgl_app_url'] === '' || repoData[0]['webgl_app_url'] === null) || (!repoData[0].hasOwnProperty('image_url') || repoData[0]['image_url'] === '' || repoData[0]['image_url'] === null))) ? 'gray' : '#058C7E'}`}}
                                className={`text-white  focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center w-1/5 font-bold ${(repoData.length != 0 && ((!repoData[0].hasOwnProperty('android_app_url') || repoData[0]['android_app_url'] === '' || repoData[0]['android_app_url'] === null) || (!repoData[0].hasOwnProperty('ios_app_url') || repoData[0]['ios_app_url'] === '' || repoData[0]['ios_app_url'] === null) || (!repoData[0].hasOwnProperty('webgl_app_url') || repoData[0]['webgl_app_url'] === '' || repoData[0]['webgl_app_url'] === null) || (!repoData[0].hasOwnProperty('image_url') || repoData[0]['image_url'] === '' || repoData[0]['image_url'] === null))) ? '' : 'hover:bg-green-800'}`}
                            >
                                Save
                            </button>
                    </div>
                    {Array.isArray(repoFields) && repoFields.map((fieldsObj, index) => {
                                const storyKey = Object.keys(fieldsObj)[0];
                                return (
                                    <div key={index}>
                                        <div className='w-full h-auto flex'>
                                            <div className='w-full px-5 flex flex-wrap mb-10'>
                                                <Form fields={fieldsObj[storyKey]} handleChange={(e: (React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>), field) => handleRepoChange(e, index, field)} data={repoData[0]}  modelTypes={modelTypes} model_upload={(formData:any) => model_upload(formData)} image_upload={(formData:any) => image_upload(formData)} repo_assest_upload={(formData:any) => assetUpload(formData)} already_repo_model_Uploaded={alreadyModelUploaded} already_repo_image_Uploaded={alreadyImageUploaded} already_repo_android_assest_Uploaded={alreadyAndroidAssestUploaded} already_repo_ios_assest_Uploaded={alreadyIosAssestUploaded} already_repo_webgl_assest_Uploaded={alreadyWebglAssestUploaded} already_repo_spatial_assest_Uploaded={alreadySpatialAssestUploaded}/>
                                            </div>
                                        </div>
                                    </div>
                                )
                            
                    })}
                </form>
                {loading &&
                    <div style={{position:'fixed',top:'0',bottom:'0',width:'100%',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
                        <div style={{background:'white',border:' 2px solid #0050C8'}} className="flex items-center rounded px-7 py-3">
                            <div className="spinner me-2"></div>
                            {
                                loadingMes === 'converting' ?  (<p className="text-blue-700">Converting please wait...</p>)  : loadingMes === 'uploading' ? <p className="text-blue-700">Uploading please wait...</p> : loadingMes === 'saving' ? <p className="text-blue-700">Saving please wait...</p> : <p className="text-blue-700">Loading please wait...</p> 
                            }
                        </div>
                    </div>
                }
                {
                    editOrNotPopup && 
                        <div style={{position:'fixed',top:'0',bottom:'0',width:'100%',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
                            <div style={{background:'white',border:' 2px solid #0050C8'}} className="flex items-center rounded px-7 py-3">
                                <div className="p-10">
                                    <button className='px-14 py-5 bg-green-400 rounded hover:bg-green-600 me-5 font-bold' onClick={()=>{
                                        setRepoData((prev: any[]) => {
                                            const updatedProject = [...prev];
                                            const project = updatedProject[0];
                                            project['edit'] = false;
                                            updatedProject[0] = project;
                                            return updatedProject;
                                        });
                                        setEditOrNotPopup(false)
                                    }}>New</button>
                                    <button className='px-14 py-5 bg-blue-400 rounded hover:bg-blue-600 text-white font-bold' onClick={()=>{
                                        setRepoData((prev: any[]) => {
                                            const updatedProject = [...prev];
                                            const project = updatedProject[0];
                                            project['edit'] = true;
                                            updatedProject[0] = project;
                                            return updatedProject;
                                        });
                                        setEditOrNotPopup(false)
                                        setRepoListShow(true)
                                    }}>Edit</button>
                                </div>
                            </div>
                        </div>
                }
                {
                    repoListShow && 
                    <div style={{position:'fixed',top:'0',bottom:'0',width:'100%',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
                        <div style={{background:'white',border:' 2px solid #0050C8'}} className="flex relative items-center rounded px-7 py-5 w-[500px] max-h-[500px] overflow-y-auto">
                            <div className="p-2 mt-20 w-full">
                                <h2 className='text-2xl mt-12 font-bold text-center'>Repository List</h2>
                                {
                                    repoList.map((list:any,index)=>{
                                        return <div className='p-2 bg-gray-200 my-2 w-full hover:bg-gray-400' onClick={()=>{
                                            setRepoData((prev: any[]) => {
                                                let data = list
                                                delete data.created_at;
                                                delete data.is_active;
                                                data['edit'] = true
                                                return [data];
                                            });
                                            setRepoListShow(false)
                                            setEdit(true)
                                        }}>{index+1+'.'+list.name}</div>
                                    })
                                }
                            </div>
                            <div className="absolute top-2 right-4">
                                <button onClick={()=>{
                                    window.location.reload()
                                }}><FontAwesomeIcon className="text-red-500 text-xl" icon={faXmarkCircle} /></button>
                            </div>
                        </div>
                    </div>
                }
            </>
}

export default Repo;